var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"d-flex justify-end mt-1"},[(!_vm.isMobile)?_c('h1',{staticClass:"app-private-title mt-1 mr-2"},[_vm._v(" "+_vm._s(_vm.title)+" ")]):_vm._e(),_c('div',{staticClass:"c-fill-notice-form"},[_vm._t("default")],2)])
}
var staticRenderFns = []

export { render, staticRenderFns }